import ClientJourney from './ClientJourney';

export default ClientJourney;
